import { SpotType } from 'src/types';

// Tattoo Spots
export const SPOTS: SpotType[] = [];
